import { ReducerActionRotaSP } from 'store/modules/types';

import { ConsultarLocalidadesRequest, Types } from './types';

export function consultarLocalidadesRequest(
	token: string,
	data: ConsultarLocalidadesRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_LOCALIDADES_REQUEST,
		token,
		payload: {
			page: data.current && data.current - 1,
			size: data.limite,
			current: data.current,
			id: data.id,
			idOrgao: data.idOrgao,
			codigo: data.codigo,
			digito: data.digito,
			nome: data.nome,
		},
	};
}
export function consultarLocalidadesSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_LOCALIDADES_SUCCESS,
		payload,
	};
}
export function consultarLocalidadesFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_LOCALIDADES_FAILURE,
		payload: null,
	};
}
export function consultarLocalidadesClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_LOCALIDADES_CLEAR,
		payload: null,
	};
}
